import { Button, Tooltip, useTheme } from '@mui/material'
import { useState } from 'react'

import rem from '~/utils/ui'

export type TInfoButton = {
  icon?: React.ReactNode
  label: string
  variant: 'outlined' | 'contained'
  onClick?: () => void
  textToCopy?: string | null
}

function InfoButton({
  icon = null,
  label,
  variant,
  onClick = () => {},
  textToCopy = '',
}: TInfoButton) {
  const [copiedText, setCopiedText] = useState('')
  const theme = useTheme()

  const handleCopyText = () => {
    if (textToCopy) {
      navigator.clipboard.writeText(textToCopy)
      setCopiedText(textToCopy)
      setTimeout(() => setCopiedText(''), 2000)
    }
  }

  const commonButtonStyle = {
    height: rem(20),
    fontSize: rem(10),
    minWidth: 'unset',
    borderRadius: rem(3),
    letterSpacing: 0,
    '@media (min-width: 0px)': {
      padding: rem(8),
    },
    '& .MuiButton-startIcon': {
      marginRight: rem(4),
      '& .MuiSvgIcon-root': {
        width: rem(14),
        height: rem(14),
        color: theme.palette.common.black,
      },
    },
    ...(variant === 'outlined' && {
      borderColor: theme.palette.divider,
      color: theme.palette.common.black,
    }),
    ...(variant === 'contained' && {
      backgroundColor: theme.palette.tertiary1,
      '&:hover': {
        backgroundColor: theme.palette.tertiary1,
      },
    }),
  }

  if (textToCopy) {
    return (
      <Tooltip
        title={copiedText ? 'Text copied to clipboard' : 'Copy to clipboard'}
        placement="top"
        sx={{ cursor: 'copy' }}
      >
        <Button
          variant={variant}
          size="small"
          startIcon={icon}
          onClick={handleCopyText}
          sx={commonButtonStyle}
        >
          {label}
        </Button>
      </Tooltip>
    )
  }

  return (
    <Button
      variant={variant}
      size="small"
      startIcon={icon}
      onClick={onClick}
      sx={commonButtonStyle}
    >
      {label}
    </Button>
  )
}

export default InfoButton
